import PointsRequest from './PointsRequest'

export default PointsRequest
